@if (institutionId > 0) {
  <div id="submodule-clienttemplates" class="cw-module-card">
    <!-- Header -->
    <div class="cw-flex-row">
      <!-- Modul-Titel -->
      <h2>{{ 'MODULES.INSTITUTIONS.CLIENTTEMPLATES.TEMPLATES' | translate }}</h2>
    </div>
    <!-- Content -->
    <div class="cw-submodules">
      <div class="cw-submodule">
        <p>{{ 'MODULES.INSTITUTIONS.CLIENTTEMPLATES.DESCRIPTION' | translate }}</p>
        <div class="cw-button-wrapper">
          <button mat-raised-button color="primary" [disabled]="loading" (click)="clickCustomerPricingList()">
            {{ '_IVF.CLIENTTEMPLATES.CUSTOMERPRICINGLIST' | translate }}
          </button>
          @if (showPricingButton) {
            <button
              mat-raised-button
              color="primary"
              [disabled]="loading"
              (click)="clickPricingExcel()">
              {{ '_IVF.CLIENTTEMPLATES.PRICINGEXCEL' | translate }}
            </button>
          }
          @if (showWSGQlikView) {
            <button
              mat-raised-button
              color="primary"
              [disabled]="loading"
              (click)="clickWSGQlikView()">
              {{ '_IVF.CLIENTTEMPLATES.WSGLIST' | translate }}
            </button>
          }
          @if (showComplaintsButton) {
            <button
              mat-raised-button
              color="primary"
              [disabled]="loading"
              (click)="clickComplaints()">
              {{ 'GENERAL.COMPLAINTS' | translate }}
            </button>
          }
        </div>
        <div [ngClass]="loading ? 'icon-spinner icon-spin' : ''"></div>
      </div>
    </div>
  </div>
}
